import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=0f9362d7"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports